import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src", "alt"]

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesIcon',
  props: {
    alt: {},
    icon: {},
    translate: {}
  },
  setup(__props: any) {

const props = __props

const translate = computed(() => (props.translate ? `translate(${props.translate})` : ''))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: require(`@/assets/grid-icons/${__props.icon}.png`),
      alt: __props.alt,
      style: _normalizeStyle({ transform: `scale(0.5) ${translate.value}` })
    }, null, 12, _hoisted_2)
  ]))
}
}

})